export default __webpack_public_path__ + "static/icon_collider_ventures_light-cff3d9df20f02b2ab6ecc28375f13a77.svg";